module.exports = __webpack_public_path__ + "img/GALLERY-IGNIS-2021-4.bd0c06a0.jpg";